import type { Action, Reducer } from 'redux';
import { IAnalyticsAction, IAppThunkAction } from '.';
import { GoogleTagManagerEvents } from '../helpers/googleTagManager';

export interface IUIState {
    errorKey?: string;
    errorMessage?: string;
    previewMode: boolean;
}

export const ERROR_MESSAGE: 'ERROR_MESSAGE' = 'ERROR_MESSAGE';
export const CLEAR_ERROR_MESSAGE: 'CLEAR_ERROR_MESSAGE' = 'CLEAR_ERROR_MESSAGE';
export const OUTBOUND_LINK: 'OUTBOUND_LINK' = 'OUTBOUND_LINK';
export const SET_PREVIEW_MODE: 'SET_PREVIEW_MODE' = 'SET_PREVIEW_MODE';

export const actionCreators = {
    displayError: (errorKey: string, additionalMessage?: string): IAppThunkAction<KnownUIActions> => (dispatch, _getState) => {
            dispatch({ type: ERROR_MESSAGE, error: errorKey, message: additionalMessage });
        },
    clearError: (): IAppThunkAction<KnownUIActions> => (dispatch) => {
        dispatch({ type: CLEAR_ERROR_MESSAGE });
    },
    outboundLink: (outboundUrl: string) =>
        ({
            type: OUTBOUND_LINK,
            outboundUrl: outboundUrl,
            googleTagManagerEvent: GoogleTagManagerEvents.ClickedOutboundLink(outboundUrl),
    } as IOutboundLinkAction),
    setPreviewMode: (previewMode: boolean): IAppThunkAction<KnownUIActions> => (dispatch) => {
        dispatch({ type: SET_PREVIEW_MODE, preview: previewMode });
    },
};

const unloadedState: IUIState = {
    errorKey: undefined,
    errorMessage: undefined,
    previewMode: false
};

export interface IErrorMessageReceived extends Action {
    type: typeof ERROR_MESSAGE;
    error: string;
    message?: string;
}

export interface IClearErrorMessageAction extends Action {
    type: typeof CLEAR_ERROR_MESSAGE;
}

export interface IOutboundLinkAction extends IAnalyticsAction {
    type: typeof OUTBOUND_LINK;
    outboundUrl: string;
}

export interface ISetPreviewModeAction extends Action {
    type: typeof SET_PREVIEW_MODE;
    preview: boolean;
}

export type KnownUIActions =
    IErrorMessageReceived
    | IClearErrorMessageAction
    | ISetPreviewModeAction;

export const reducer: Reducer<IUIState> = (state: IUIState | undefined, incomingAction: Action): IUIState => {
    if (state === undefined) return unloadedState;

    const action: KnownUIActions = incomingAction as KnownUIActions;
    switch (action.type) {
        case ERROR_MESSAGE:
            return {
                ...state,
                errorKey: action.error,
                errorMessage: action.message,
            };
        case CLEAR_ERROR_MESSAGE:
            return {
                ...state,
                errorKey: undefined,
                errorMessage: undefined,
            };
        case SET_PREVIEW_MODE:
            return {
                ...state,
                previewMode: action.preview
            }
        default:
            return {
                ...state,
                errorKey: state.errorKey,
            };
    }
};
